import { apiClient } from './client';

export interface UpdateProfileRequest {
  name?: string;
  email?: string;
  currency?: string;
  timezone?: string;
  onboardingStatus?: string;
}

export interface UpdatePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface UserProfile {
  id: string;
  email: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  currency: string;
  timezone: string;
  isActive: boolean;
  onboardingStatus?: string;
  createdAt: string;
  updatedAt: string;
}


export interface UpdateProfileResponse {
  success: boolean;
  message: string;
  data: {
    user: UserProfile;
  };
}

export interface UpdatePasswordResponse {
  success: boolean;
  message: string;
}

class UserService {
  async updateProfile(profileData: UpdateProfileRequest): Promise<UpdateProfileResponse> {
    const response = await apiClient.patch('/users/profile', profileData);
    return response.data;
  }

  async updatePassword(passwordData: UpdatePasswordRequest): Promise<UpdatePasswordResponse> {
    const response = await apiClient.patch('/users/password', passwordData);
    return response.data;
  }

  async getProfile(): Promise<UpdateProfileResponse> {
    const response = await apiClient.get('/users/profile');
    return response.data;
  }

  async detectLocation(): Promise<{
    success: boolean;
    data: {
      currency: string;
      timezone: string;
      country?: string;
      city?: string;
    };
  }> {
    const response = await apiClient.get('/users/detect-location');
    return response.data;
  }

  async deleteAccount(id: string): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.delete(`/users/${id}`);
    return response.data;
  }
}

export const userService = new UserService();
